import React from 'react'
import { ContentHeader } from '../../layout/Content'

function StockInItemHeader() {
  return ( <ContentHeader title='Stock-In Items'/> )
}

export default React.memo(StockInItemHeader)
